import { render, staticRenderFns } from "./traceManageDetail.vue?vue&type=template&id=204cc588&scoped=true&"
import script from "./traceManageDetail.vue?vue&type=script&lang=js&"
export * from "./traceManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./traceManageDetail.vue?vue&type=style&index=0&id=204cc588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204cc588",
  null
  
)

export default component.exports